<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Factores Kostick</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="kostikFactorForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Crear / actualizar factor</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Factor</label>
                                    <select formControlName="factor" class="form-control custom-select">
                                        <option selected value="Grado de energía">Grado de Energía</option>
                                        <option value="Liderazgo">Liderazgo</option>
                                        <option value="Modo de Vida">Modo de Vida</option>
                                        <option value="Naturaleza Social">Naturaleza Social</option>
                                        <option value="Adaptación al Trabajo">Adaptación al Trabajo</option>
                                        <option value="Naturaleza Emocional">Naturaleza Emocional</option>
                                        <option value="Subordinación">Subordinación</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Puntaje</label>
                                    <input formControlName="score" type="number"  class="form-control" placeholder="Puntaje">
                                </div>
                            </div>

                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Dimensión</label>
                                    <select formControlName="dimension" class="form-control custom-select">
                                        <option selected value="(N) Necesidad de terminar una tarea">(N) Necesidad de terminar una tarea</option>
                                        <option value="(A) Necesidad de logro">(A) Necesidad de logro</option>
                                        <option value="(P) Necesidad de controlar a otros">(P) Necesidad de controlar a otros</option>
                                        <option value="(X) Necesidad de ser notificado">(X) Necesidad de ser notificado</option>
                                        <option value="(B) Necesidad de pertenecer al grupo">(B) Necesidad de pertenecer al grupo</option>
                                        <option value="(O) Necesidad de acercamiento y afecto">(O) Necesidad de acercamiento y afecto</option>
                                        <option value="(Z) Necesidad de cambio/Necesidad de no modificar">(Z) Necesidad de cambio/Necesidad de no modificar</option>
                                        <option value="(K) Necesidad de ser agresivo, a la defensiva">(K) Necesidad de ser agresivo, a la defensiva</option>
                                        <option value="(F) Necesidad de apoyo del supervisor (de contar con autoridad)">(F) Necesidad de apoyo del supervisor (de contar con autoridad)</option>
                                        <option value="(W) Necesidad de reglas y supervisión">(W) Necesidad de reglas y supervisión</option>
                                        <option value="(G) Desempeñar una intensa actividad">(G) Desempeñar una intensa actividad</option>
                                        <option value="(L) Actividad de liderazgo">(L) Actividad de liderazgo</option>
                                        <option value="(I) Facilidad para tomar decisiones/impulsividad">(I) Facilidad para tomar decisiones/impulsividad</option>
                                        <option value="(T) Tipo siempre activo">(T) Tipo siempre activo</option>
                                        <option value="(V) Tipo vigoroso">(V) Tipo vigoroso</option>
                                        <option value="(S) Extensión social (sociable)">(S) Extensión social (sociable)</option>
                                        <option value="(R) Tipo teórico">(R) Tipo teórico</option>
                                        <option value="(C) Tipo organizado">(C) Tipo organizado</option>
                                        <option value="(E) Tipo emocionalmente restringido">(E) Tipo emocionalmente restringido</option>
                                        <option value="(D) Interés en trabajo con detalles">(D) Interés en trabajo con detalles</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Descripción</label>
                                    <input formControlName="description" type="text"  class="form-control" placeholder="Descripción">
                                </div>
                            </div>
                        </div>
                        
                    </div>

                    <div class="row m-t-20">
                        <div class="form-actions m-r-10 m-l-10">
                            <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Crear/reemplazar</button>
                        </div>
    
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Interpretaciónes</h4>
            </div>
            <div class="card-body">
              
                    <div class="form-body">
                        <h3 class="card-title">Crear / actualizar interpretación</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Factor</label>
                                    <select [(ngModel)]="factor" class="form-control custom-select">
                                        <option selected value="Grado de energía">Grado de Energía</option>
                                        <option value="Liderazgo">Liderazgo</option>
                                        <option value="Modo de Vida">Modo de Vida</option>
                                        <option value="Naturaleza Social">Naturaleza Social</option>
                                        <option value="Adaptación al Trabajo">Adaptación al Trabajo</option>
                                        <option value="Naturaleza Emocional">Naturaleza Emocional</option>
                                        <option value="Subordinación">Subordinación</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Dimensión</label>
                                    <select [(ngModel)]="dimension" class="form-control custom-select">
                                        <option selected value="(N) Necesidad de terminar una tarea">(N) Necesidad de terminar una tarea</option>
                                        <option value="(A) Necesidad de logro">(A) Necesidad de logro</option>
                                        <option value="(P) Necesidad de controlar a otros">(P) Necesidad de controlar a otros</option>
                                        <option value="(X) Necesidad de ser notificado">(X) Necesidad de ser notificado</option>
                                        <option value="(B) Necesidad de pertenecer al grupo">(B) Necesidad de pertenecer al grupo</option>
                                        <option value="(O) Necesidad de acercamiento y afecto">(O) Necesidad de acercamiento y afecto</option>
                                        <option value="(Z) Necesidad de cambio/Necesidad de no modificar">(Z) Necesidad de cambio/Necesidad de no modificar</option>
                                        <option value="(K) Necesidad de ser agresivo, a la defensiva">(K) Necesidad de ser agresivo, a la defensiva</option>
                                        <option value="(F) Necesidad de apoyo del supervisor (de contar con autoridad)">(F) Necesidad de apoyo del supervisor (de contar con autoridad)</option>
                                        <option value="(W) Necesidad de reglas y supervisión">(W) Necesidad de reglas y supervisión</option>
                                        <option value="(G) Desempeñar una intensa actividad">(G) Desempeñar una intensa actividad</option>
                                        <option value="(L) Actividad de liderazgo">(L) Actividad de liderazgo</option>
                                        <option value="(I) Facilidad para tomar decisiones/impulsividad">(I) Facilidad para tomar decisiones/impulsividad</option>
                                        <option value="(T) Tipo siempre activo">(T) Tipo siempre activo</option>
                                        <option value="(V) Tipo vigoroso">(V) Tipo vigoroso</option>
                                        <option value="(S) Extensión social (sociable)">(S) Extensión social (sociable)</option>
                                        <option value="(R) Tipo teórico">(R) Tipo teórico</option>
                                        <option value="(C) Tipo organizado">(C) Tipo organizado</option>
                                        <option value="(E) Tipo emocionalmente restringido">(E) Tipo emocionalmente restringido</option>
                                        <option value="(D) Interés en trabajo con detalles">(D) Interés en trabajo con detalles</option>
                                    </select>
                                </div>
                            </div>

                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Bajo positivo</label>
                                    <input [(ngModel)]="lowPositive" type="text"  class="form-control" placeholder="Bajo positivo">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Bajo negativo</label>
                                    <input [(ngModel)]="lowNegative" type="text"  class="form-control" placeholder="Bajo negativo">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Medio positivo</label>
                                    <input [(ngModel)]="midPositive" type="text"  class="form-control" placeholder="Medio positivo">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Medio negativo</label>
                                    <input [(ngModel)]="midNegative" type="text"  class="form-control" placeholder="Medio negativo">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Alto positivo</label>
                                    <input [(ngModel)]="highPositive" type="text"  class="form-control" placeholder="Alto positivo">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Alto negativo</label>
                                    <input [(ngModel)]="highNegative" type="text"  class="form-control" placeholder="Alto negativo">
                                </div>
                            </div>
                        </div>
                        
                    </div>

                    <div class="row m-t-20">
                        <div class="form-actions m-r-10 m-l-10">
                            <button type="button" class="btn btn-success" (click)="createInterpretation()" > <i class="fa fa-check"></i> Crear/reemplazar</button>
                        </div>
    
                    </div>
   
            </div>
        </div>
    </div>
</div>

<div class="col-12">
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">Interpretaciones declaradas</h4>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Factor</th>
                            <th>Dimensión</th>
                            <th>Bajo</th>
                            <th>Medio</th>
                            <th>Alto</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of interpretations">
                            <td>{{r.factor}}</td>
                            <td>{{r.dimension}}</td>
                            <td><p>POSITIVO: {{r.lowPositive}}</p><p>NEGATIVO: {{r.lowNegative}}</p></td>
                            <td><p>POSITIVO: {{r.midPositive}}</p><p>NEGATIVO: {{r.midNegative}}</p></td>
                            <td><p>POSITIVO: {{r.highPositive}}</p><p>NEGATIVO: {{r.highNegative}}</p></td>
        
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>